import Index from '@/views/Admin/Index';
import UserSearch from '@/views/Admin/UserSearch';

const routes = [
  {
    name: 'admin/index',
    path: '/admin',
    component: Index,
    meta: {
      icon: 'crown',
      title: 'Metrics',
    },
  },
  {
    name: 'admin/users/search',
    path: '/admin/users/search',
    component: UserSearch,
    meta: {
      icon: 'search',
      title: 'Search Users',
    },
  },
];

export default routes;
